import { createSlice } from "@reduxjs/toolkit";
import { deleteMileage, getMileageList } from "./_mileageAction";


interface MileageState {
  mileageList: any[];
  loading: boolean;
  error: string | null;
  totalCount: number;
  mileageRequestList: any[];
}

const initialState: MileageState = {
  mileageList: [],
  loading: false,
  error: null,
  totalCount: 0,
  mileageRequestList: [],
};


export const mileageReducer = createSlice({
  name: "mileage",
  initialState: initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Log Hour List
      .addCase(getMileageList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getMileageList.fulfilled, (state, action) => {
        state.loading = false;
        state.mileageList = action.payload?.data;
        state.totalCount = action.payload?.count;
      })
      .addCase(getMileageList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      // Archive mileage
      .addCase(deleteMileage.fulfilled, (state, action) => {
        state.mileageList = state.mileageList.filter((mileage) => mileage?.uuid !== action.payload?.data?.uuid);
      })
      .addCase(deleteMileage.rejected, (state, action) => {
        state.error = action.payload as string;
      })
  },

});


export const { clearError } = mileageReducer.actions;
export default mileageReducer;